import { Text } from "@shopify/polaris"

const StepHeader = (props: { title: string; description: string }) => {
  const { title, description } = props

  return (
    <div className="flex flex-col gap-2">
      <Text as="h1" variant="headingXl">
        {title}
      </Text>
      <Text as="p" tone="subdued" variant="bodyLg">
        {description}
      </Text>
    </div>
  )
}

export default StepHeader
